import React, { useLayoutEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Layout } from 'app/ecommerce/common'
import styled from 'styled-components'
import { media, ResponsiveContainer } from 'app/assets/styles'
import { H2 } from 'app/common/typography'
import { colors as oldColors } from 'shared/assets/styles'
import { FeatureToggle } from 'app/common/feature-toggle'
import { featureCodes } from 'shared/utils'
import { useDispatch, useSelector } from 'react-redux'
import { clearSearch, search } from 'shared/store/store-locator'
import type { RootState } from 'shared/store/reducers'
import { SplitRestaurantChoiceScreen } from 'app/ecommerce/common/components/restaurant-choice'
import { fetchOrders } from 'shared/store/ecommerce/order'
import { pageMetadata } from 'shared/store/metadata'
import { fetchFavoriteRestaurant } from 'shared/store/kingdom/profile'
import { InputAddressAutocomplete } from 'app/store-locator/input-address-autocomplete'

const { tertiary } = oldColors

type StoreProps = {
    authenticated: boolean,
    userPosition: any
}

export const RestaurantChoice = () => {
    const dispatch = useDispatch()
    const intl = useIntl()
    const { authenticated, userPosition }: StoreProps = useSelector(
        (state: RootState) => ({
            authenticated: state.userState.authenticated,
            userPosition: state.storeLocatorPageState.userPosition
        })
    )

    const [listView, setListView] = useState(true)

    useLayoutEffect(() => {
        dispatch(clearSearch())
        userPosition && loadNearestRestaurants()
        !!authenticated && dispatch(fetchFavoriteRestaurant())
        dispatch(fetchOrders({ days: 1 }))
        dispatch(pageMetadata({}))
        return () => {
            dispatch(clearSearch())
        }
    }, [])

    const loadNearestRestaurants = () => {
        dispatch(search({ coords: userPosition, radius: 3000 }, 'nearest'))
    }

    return (
        <FeatureToggle feature={featureCodes.CLICK_AND_COLLECT} shouldRedirect>
            <Layout
                background="plain"
                border
                showLogoBK
                closeEnabled
                backgroundColor={tertiary}>
                <StyledContainer listView={listView}>
                    <StyledH2>
                        {intl.formatMessage({
                            id: 'clickandcollect.choose.restaurant'
                        })}
                    </StyledH2>
                    <AddressSearchContainer>
                        <InputAddressAutocomplete placeholder="clickandcollect.search.placeholder" />
                    </AddressSearchContainer>
                    <SplitRestaurantChoiceScreen
                        listView={listView}
                        setListView={setListView}
                    />
                </StyledContainer>
            </Layout>
        </FeatureToggle>
    )
}

const StyledContainer = styled(ResponsiveContainer)`
    margin: 90px auto 0;
    min-height: calc(100vh - 90px);

    ${props => !props.listView && 'width: 100vw;'};

    ${media.medium`
        margin-top: 120px;
        min-height: calc(100vh - 120px);
    `};
`

const StyledH2 = styled(H2)`
    margin: 25px;
    text-align: center;
`

const AddressSearchContainer = styled(ResponsiveContainer)`
    margin: 0 auto;
    width 100%;
`
